module.exports = "<div style=\"width:100%;height:100%; top:0;left:0;z-index:99999;background-color:rgba(0,0,0,0.4); position:fixed;\" *ngIf=\"isLoading\">\n    <object type=\"image/svg+xml\" data=\"assets/images/temp/nirvana.svg\" class=\"spinner\">\n       \n    </object>\n</div>\n<router-outlet></router-outlet>\n\n\n\n<app-tether-dialog></app-tether-dialog>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = 9